module.exports = __webpack_public_path__ + "static/img/img_form_2@2x_ja.9ad7f9d5.png";